export default __webpack_public_path__ + "static/art_institvte-d5a7f582a3d2b2e172587f3093a5f3fb.svg";